















































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
    components: {}
})
export default class CmHeader extends Vue {
    @Prop()
    public imgProfile;
    public apps = [];
    public light;
    public navButton;
    public links;

    public showApps: boolean = false;
    public showCollapse: boolean = false;
    public userDropdownMenu: boolean = false;

    public get footer() {
        return this.$store.getters.footer;
    }
    public menuItems: any = {
        // dashboard: '/',
        profile: "/profile",
        // talks: '/talks',
        // articles: '/articles',
        // webinars: '/webinars',
        papers: "/papers",
        trials: "/trials",
        communities: "/communities",
        tickets: "/events"
        // jobs: '/jobs'
    };

    public async mounted() {
        const response = await fetch("https://www.codemotion.com/apps.json");
        this.apps = await response.json();
        // (window as any).menuCarousel = (window as any).$("#slider-menu ul");
        // (window as any).menuCarousel.itemslide({
        //     left_sided: false,
        //     start: 0,
        //     disable_autowidth: false
        // });
    }

    public get conf() {
        return this.$store.getters.conf;
    }

    public logout() {
        window.location.replace(
            this.$store.getters.conf.sso_url +
                "/#/SignOut?hop=" +
                encodeURI(window.location.href)
        );
    }

    public get isFromAppMobile(): boolean {
        return this.$store.getters.isFromAppMobile;
    }

    public goToCheckin() {
        window.open(this.$store.getters.conf.checkin_url, "blank");
    }

    public toggleUserSubmenu() {
        if (this.userDropdownMenu === true) {
            this.userDropdownMenu = false;
        } else {
            this.userDropdownMenu = true;
        }
    }
}
